const TWITTER_SHARE_LINK = "https://twitter.com/share?url="

export const getTwitterShareLink = (targetUrl: string): string => {
  return `${TWITTER_SHARE_LINK}${targetUrl}`
}
